import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import CopyButton from "../../../../components/CopyButton/CopyButton";
import { ICalendarControlXl } from "../../../../models/calendar-control";
import { prettyJson, translationPath } from "./utils";

interface ICalendarControlJsonModalProps {
  calendarControl: ICalendarControlXl;
  onClose: () => void;
}

const CalendarControlJsonModal: React.FC<ICalendarControlJsonModalProps> = ({
  calendarControl,
  onClose,
}) => {
  const { t } = useTranslation();

  const json = useMemo(
    () => prettyJson(calendarControl.jsonContent),
    [calendarControl.jsonContent],
  );

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <span>
            {t(translationPath + "json_modal.title") || "JSON da requisição"} -{" "}
            {calendarControl.identifier}
          </span>
          <CopyButton
            value={json}
            disabled={!json}
            label={t(translationPath + "copy_json") || "Copiar JSON"}
          />
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        {json ? (
          <Typography
            component="pre"
            variant="body2"
            sx={{
              m: 0,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              fontFamily: "monospace",
              fontSize: "0.8rem",
            }}
          >
            {json}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.secondary">
            {t(translationPath + "json_modal.empty") || "Sem JSON registrado."}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t(translationPath + "close") || "Fechar"}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CalendarControlJsonModal;
